<template>
    <div class="block-parallax" v-obvis="visibilityChanged">
        <div class="block-parallax__box" ref="box">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        speed: {
            type: [String, Number],
            default: '10'
        },
        direction: {
            type: String,
            default: 'right'
        },
        transform: {
            type: String,
            default: 'rotate'
        },
        offset: {
            type: [String, Number],
            default: 0
        },
        fixed: {
            type: Boolean,
            default: false
        },
        scrollListener: {
            type: Boolean,
            default: false
        },
        path: {
            type: String,
            default: ''
        },
        options: {
            type: Object,
            default: () => new Object
        }
    },
    data () {
        return {
            isVisible: false,
            i: 10,
            lastScroll: 0,
            pathEl: null,
            pathLength: 0,
            pathOptions: {
                length: 100,
                scalePath: 1
            }
        }
    },
    methods: {
        visibilityChanged (isVisible) {
            this.isVisible = isVisible
        },
        transformElement () {
            const elem = this.$el
            const elemBox = this.$refs.box
            const positionY = elem.getBoundingClientRect().y
            const windowHeight = window.innerHeight
            let value = window.pageYOffset / this.speed

            if (windowHeight - positionY < this.offset) return

            if (this.fixed) {
                value = (windowHeight - positionY - this.offset) / this.speed
            }

            if (this.transform === 'bypath') {
                if (!this.pathEl) return false
                if (value < 0 || value > this.pathOptions.length) return false;
                let prcnt = 0,
                    pt = null,
                    deg = 0

                prcnt = (value * this.pathLength) / this.pathOptions.length;

                pt = this.pathEl.getPointAtLength(prcnt);
                pt.x = pt.x * this.pathOptions.scalePath;
                pt.y = pt.y * this.pathOptions.scalePath;
                deg = this.calcAngle(prcnt);

                elemBox.style.transform = 'translate('+pt.x+'px,'+pt.y+'px) rotateZ('+deg+'deg)';
            } else if (this.isVisible) {
                if (this.transform === 'rotate' && this.direction === 'right') {
                    elem.style.transform = `rotate(${value}deg)`
                }
                if (this.transform === 'rotate' && this.direction === 'left') {
                    elem.style.transform = `rotate(-${value}deg)`
                }
                else if (this.transform === 'translateX') {
                    elem.style.transform = `translateX(${value}px)`
                }
                else if (this.transform === 'translateY') {
                    elem.style.transform = `translateY(${(value) * -1}px)`
                }
                else if (this.transform === 'animate1') {
                    elem.style.transform = `translateX(${(value)}px)`
                    if (value > 10 && value < 40) {
                        elemBox.style.transform = `translateY(0) rotate(5deg)`
                    }
                    if (value > 40 && value < 70) {
                        elemBox.style.transform = `translateY(0) rotate(8deg)`
                    }
                    if (value > 70 && value < 90) {
                        elemBox.style.transform = `translateY(0) rotate(10deg)`
                    }
                    if (value > 90 && value < 100) {
                        elemBox.style.transform = `translateY(0) rotate(12deg)`
                    }
                    if (value > 90 && value < 100) {
                        elemBox.style.transform = `translateY(0) rotate(12deg)`
                    }
                    if (value > 100 && value < 120) {
                        elemBox.style.transform = `translateY(0) rotate(14deg)`
                    }
                    if (value > 120 && value < 130) {
                        elemBox.style.transform = `translateY(4px) rotate(19deg)`
                    }
                    if (value > 130 && value < 140) {
                        elemBox.style.transform = `translateY(5px) rotate(21deg)`
                    }
                    if (value > 140 && value < 150) {
                        elemBox.style.transform = `translateY(11px) rotate(26deg)`
                    }
                    if (value > 150 && value < 160) {
                        elemBox.style.transform = `translateY(13px) rotate(27deg)`
                    }
                    if (value > 170 && value < 180) {
                        elemBox.style.transform = `translateY(15px) rotate(29deg)`
                    }
                    if (value > 180 && value < 190) {
                        elemBox.style.transform = `translateY(18px) rotate(29deg)`
                    }
                    if (value > 190 && value < 200) {
                        elemBox.style.transform = `translateY(23px) rotate(31deg)`
                    }
                    if (value > 200 && value < 220) {
                        elemBox.style.transform = `translateY(32px) rotate(31deg)`
                    }
                    if (value > 220 && value < 230) {
                        elemBox.style.transform = `translateY(35px) rotate(31deg)`
                    }
                    if (value > 230 && value < 240) {
                        elemBox.style.transform = `translateY(37px) rotate(31deg)`
                    }
                    if (value > 240 && value < 250) {
                        elemBox.style.transform = `translateY(42px) rotate(31deg)`
                    }
                    if (value > 250 && value < 260) {
                        elemBox.style.transform = `translateY(45px) rotate(31deg)`
                    }
                    if (value > 260 && value < 270) {
                        elemBox.style.transform = `translateY(51px) rotate(31deg)`
                    }
                    if (value > 270 && value < 280) {
                        elemBox.style.transform = `translateY(55px) rotate(31deg)`
                    }
                    if (value > 280 && value < 300) {
                        elemBox.style.transform = `translateY(57px) rotate(31deg)`
                    }
                    if (value > 300 && value < 310) {
                        elemBox.style.transform = `translateY(64px) rotate(31deg)`
                    }
                    if (value > 310 && value < 320) {
                        elemBox.style.transform = `translateY(69px) rotate(31deg)`
                    }
                    if (value > 320 && value < 330) {
                        elemBox.style.transform = `translateY(73px) rotate(35deg)`
                    }
                    if (value > 330 && value < 340) {
                        elemBox.style.transform = `translateY(79px) rotate(35deg)`
                    }
                    if (value > 340 && value < 350) {
                        elemBox.style.transform = `translateY(82px) rotate(35deg)`
                    }
                    if (value > 350 && value < 360) {
                        elemBox.style.transform = `translateY(86px) rotate(35deg)`
                    }
                    if (value > 360 && value < 370) {
                        elemBox.style.transform = `translateY(88px) rotate(35deg)`
                    }
                    if (value > 370 && value < 380) {
                        elemBox.style.transform = `translateY(93px) rotate(35deg)`
                    }
                    if (value > 380 && value < 390) {
                        elemBox.style.transform = `translateY(99px) rotate(35deg)`
                    }
                }
                else if (this.transform === 'animate2') {
                    elem.style.transform = `translateX(${(value)}px)`
                    if (value > 10 && value < 20) {
                        elemBox.style.transform = `translateY(-4px) rotate(-26deg)`
                    }
                    else if (value > 20 && value < 30) {
                        elemBox.style.transform = `translateY(-9px) rotate(-22deg)`
                    }
                    else if (value > 30 && value < 40) {
                        elemBox.style.transform = `translateY(-13px) rotate(-21deg)`
                    }
                    else if (value > 40 && value < 50) {
                        elemBox.style.transform = `translateY(-16px) rotate(-19deg)`
                    }
                    else if (value > 50 && value < 60) {
                        elemBox.style.transform = `translateY(-16px) rotate(-26deg)`
                    }
                    else if (value > 60 && value < 70) {
                        elemBox.style.transform = `translateY(-17px) rotate(-15deg)`
                    }
                    else if (value > 70 && value < 80) {
                        elemBox.style.transform = `translateY(-18px) rotate(-14deg)`
                    }
                    else if (value > 80 && value < 110) {
                        elemBox.style.transform = `translateY(-21px) rotate(-10deg)`
                    }
                    else if (value > 110 && value < 120) {
                        elemBox.style.transform = `translateY(-21px) rotate(-7deg)`
                    }
                    else if (value > 120 && value < 130) {
                        elemBox.style.transform = `translateY(-26px) rotate(-6deg)`
                    }
                    else if (value > 130 && value < 160) {
                        elemBox.style.transform = `translateY(-23px) rotate(-6deg)`
                    }
                    else if (value > 160 && value < 190) {
                        elemBox.style.transform = `translateY(-21px) rotate(-4deg)`
                    }
                    else if (value > 190 && value < 220) {
                        elemBox.style.transform = `translateY(-21px) rotate(-6deg)`
                    }
                    else if (value > 220 && value < 230) {
                        elemBox.style.transform = `translateY(-21px) rotate(-13deg)`
                    }
                    else if (value > 230 && value < 240) {
                        elemBox.style.transform = `translateY(-21px) rotate(-13deg)`
                    }
                    else if (value > 240 && value < 250) {
                        elemBox.style.transform = `translateY(-21px) rotate(-26deg)`
                    }
                    else if (value > 250 && value < 260) {
                        elemBox.style.transform = `translateY(-26px) rotate(-30deg)`
                    }
                    else if (value > 260 && value < 270) {
                        elemBox.style.transform = `translateY(-34px) rotate(-30deg)`
                    }
                    else if (value > 270 && value < 280) {
                        elemBox.style.transform = `translateY(-38px) rotate(-30deg)`
                    }
                    else if (value > 280 && value < 290) {
                        elemBox.style.transform = `translateY(-45px) rotate(-30deg)`
                    }
                    else if (value > 290 && value < 300) {
                        elemBox.style.transform = `translateY(-50px) rotate(-30deg)`
                    }
                    else if (value > 300 && value < 310) {
                        elemBox.style.transform = `translateY(-56px) rotate(-30deg)`
                    }
                    else if (value > 310 && value < 320) {
                        elemBox.style.transform = `translateY(-61px) rotate(-30deg)`
                    }
                    else if (value > 320 && value < 330) {
                        elemBox.style.transform = `translateY(-67px) rotate(-30deg)`
                    }
                    else if (value > 330 && value < 340) {
                        elemBox.style.transform = `translateY(-73px) rotate(-30deg)`
                    }
                    else if (value > 340 && value < 350) {
                        elemBox.style.transform = `translateY(-76px) rotate(-30deg)`
                    }
                    else if (value > 350 && value < 360) {
                        elemBox.style.transform = `translateY(-76px) rotate(-30deg)`
                    }
                }
                else if (this.transform === 'animate3') {
                    elem.style.transform = `translateX(-${(value)}px)`
                    if (value > 10 && value < 20) {
                        elemBox.style.transform = `translate(0, -2px ) rotate(-3deg)`
                    }
                    if (value > 20 && value < 30) {
                        elemBox.style.transform = `translate(0, -2px ) rotate(-5deg)`
                    }
                    if (value > 30 && value < 90) {
                        elemBox.style.transform = `translate(0, -2px ) rotate(-12deg)`
                    }
                    if (value > 90 && value < 140) {
                        elemBox.style.transform = `translate(0, -4px ) rotate(-14deg)`
                    }
                    if (value > 140 && value < 150) {
                        elemBox.style.transform = `translate(0, -6px ) rotate(-12deg)`
                    }
                    if (value > 150 && value < 170) {
                        elemBox.style.transform = `translate(0, -8px ) rotate(-10deg)`
                    }
                    if (value > 170 && value < 180) {
                        elemBox.style.transform = `translate(0, -10px ) rotate(-7deg)`
                    }
                    if (value > 180 && value < 190) {
                        elemBox.style.transform = `translate(0, -12px ) rotate(-5deg)`
                    }
                    if (value > 190 && value < 200) {
                        elemBox.style.transform = `translate(0, -15px ) rotate(-2deg)`
                    }
                    if (value > 200 && value < 210) {
                        elemBox.style.transform = `translate(0, -15px ) rotate(0deg)`
                    }
                    if (value > 210 && value < 220) {
                        elemBox.style.transform = `translate(0, -18px ) rotate(3deg)`
                    }
                    if (value > 220 && value < 230) {
                        elemBox.style.transform = `translate(0, -223px ) rotate(6deg)`
                    }
                    if (value > 240 && value < 250) {
                        elemBox.style.transform = `translate(0, -27px ) rotate(10deg)`
                    }
                    if (value > 250 && value < 260) {
                        elemBox.style.transform = `translate(0, -30px ) rotate(15deg)`
                    }
                    if (value > 260 && value < 270) {
                        elemBox.style.transform = `translate(0px, -36px) rotate(23deg)`
                    }
                    if (value > 270 && value < 280) {
                        elemBox.style.transform = `translate(0px, -46px) rotate(23deg)`
                    }
                    if (value > 280 && value < 290) {
                        elemBox.style.transform = `translate(0px, -58px) rotate(29deg)`
                    }
                    if (value > 290 && value < 300) {
                        elemBox.style.transform = `translate(0px, -58px) rotate(35deg)`
                    }
                }
                else if (this.transform === 'animate4') {
                    elem.style.transform = `translateX(${(value)}px)`
                    if (value > 10 && value < 20) {
                        elemBox.style.transform = `translate(0, -8px) rotate(6deg)`
                    }
                    if (value > 20 && value < 30) {
                        elemBox.style.transform = `translate(0,-17px) rotate(6deg)`
                    }
                    if (value > 30 && value < 40) {
                        elemBox.style.transform = `translate(0, -27px) rotate(6deg)`
                    }
                    if (value > 40 && value < 50) {
                        elemBox.style.transform = `translate(0, -36px) rotate(14deg)`
                    }
                    if (value > 50 && value < 60) {
                        elemBox.style.transform = `translate(0, -44px) rotate(14deg)`
                    }
                    if (value > 60 && value < 70) {
                        elemBox.style.transform = `translate(0, -51px) rotate(14deg)`
                    }
                    if (value > 70 && value < 80) {
                        elemBox.style.transform = `translate(0, -57px) rotate(14deg)`
                    }
                    if (value > 80 && value < 90) {
                        elemBox.style.transform = `translate(0, -63px) rotate(14deg)`
                    }
                    if (value > 90 && value < 100) {
                        elemBox.style.transform = `translate(0, -67px) rotate(18deg)`
                    }
                    if (value > 100 && value < 110) {
                        elemBox.style.transform = `translate(0, -72px) rotate(18deg)`
                    }
                    if (value > 110 && value < 120) {
                        elemBox.style.transform = `translate(0, -84px) rotate(18deg)`
                    }
                    if (value > 120 && value < 150) {
                        elemBox.style.transform = `translate(0, -92px) rotate(24deg)`
                    }
                    if (value > 150 && value < 160) {
                        elemBox.style.transform = `translate(0, -103px) rotate(18deg)`
                    }
                    if (value > 160 && value < 170) {
                        elemBox.style.transform = `translate(0, -115px) rotate(18deg)`
                    }
                    if (value > 170 && value < 180) {
                        elemBox.style.transform = `translate(0, -119px) rotate(13deg)`
                    }
                    if (value > 180 && value < 190) {
                        elemBox.style.transform = `translate(0, -122px) rotate(6deg)`
                    }
                    if (value > 190 && value < 200) {
                        elemBox.style.transform = `translate(0, -131px) rotate(6deg)`
                    }
                    if (value > 200 && value < 210) {
                        elemBox.style.transform = `translate(0, -141px) rotate(6deg)`
                    }
                    if (value > 210 && value < 220) {
                        elemBox.style.transform = `translate(0, -150px) rotate(6deg)`
                    }
                    if (value > 220 && value < 230) {
                        elemBox.style.transform = `translate(0, -1606px) rotate(6deg)`
                    }
                    if (value > 230 && value < 240) {
                        elemBox.style.transform = `translate(0, -170px) rotate(6deg)`
                    }
                    if (value > 240 && value < 250) {
                        elemBox.style.transform = `translate(0, -187px) rotate(-6deg)`
                    }
                    if (value > 250 && value < 260) {
                        elemBox.style.transform = `translate(0, -187px) rotate(-6deg)`
                    }
                    if (value > 260 && value < 270) {
                        elemBox.style.transform = `translate(0, -205px) rotate(7deg)`
                    }
                    if (value > 270 && value < 280) {
                        elemBox.style.transform = `translate(0, -205px) rotate(-7deg)`
                    }
                    if (value > 280 && value < 290) {
                        elemBox.style.transform = `translate(0, -219px) rotate(-7deg)`
                    }
                    if (value > 290 && value < 300) {
                        elemBox.style.transform = `translate(0, -232px) rotate(-7deg)`
                    }
                    if (value > 300 && value < 310) {
                        elemBox.style.transform = `translate(0, -249px) rotate(-20deg)`
                    }
                }
                else if (this.transform === 'animate5') {
                    elem.style.transform = `translateX(${(value)}px)`
                    if (value > 10 && value < 20) {
                        elemBox.style.transform = `translate(0, 0) rotate(3deg)`
                    }
                    if (value > 20 && value < 30) {
                        elemBox.style.transform = `translate(0, 0) rotate(8deg)`
                    }
                    if (value > 30 && value < 40) {
                        elemBox.style.transform = `translate(0px, -3px) rotate(11deg)`
                    }
                    if (value > 40 && value < 50) {
                        elemBox.style.transform = `translate(0px, -7px) rotate(16deg)`
                    }
                    if (value > 50 && value < 60) {
                        elemBox.style.transform = `translate(0px, -7px) rotate(20deg)`
                    }
                    if (value > 60 && value < 90) {
                        elemBox.style.transform = `translate(0px, -9px) rotate(24deg)`
                    }
                    if (value > 90 && value < 160) {
                        elemBox.style.transform = `translate(0px, -10px) rotate(27deg)`
                    }
                    if (value > 160 && value < 170) {
                        elemBox.style.transform = `translate(0px, -10px) rotate(24deg)`
                    }
                    if (value > 170 && value < 180) {
                        elemBox.style.transform = `translate(0px, -10px) rotate(19deg)`
                    }
                    if (value > 180 && value < 210) {
                        elemBox.style.transform = `translate(0px, -12px) rotate(19deg)`
                    }
                    if (value > 210 && value < 230) {
                        elemBox.style.transform = `translate(0px, -15px) rotate(15deg)`
                    }
                    if (value > 230 && value < 240) {
                        elemBox.style.transform = `translate(0px, -18px) rotate(10deg)`
                    }
                }
            }
        },
        calcAngle (prcnt) {
            let a = (prcnt - .25 < 0) ? prcnt : prcnt - .25,
                b = (prcnt + .25 > this.pathLength) ? this.pathLength : prcnt + .25,
                pta = this.pathEl.getPointAtLength(a),
                ptb = this.pathEl.getPointAtLength(b)

            return Math.atan2(pta.y - ptb.y, pta.x - ptb.x) / Math.PI * 180
        },
        initByPath () {
            if (!this.path) return false
            this.pathEl = document.createElementNS('http://www.w3.org/2000/svg', 'path')
            this.pathEl.setAttribute('d', this.path)
            this.pathLength = this.pathEl.getTotalLength()
            Object.assign(this.pathOptions, this.options)
        }
    },
    mounted () {
        if (document.documentElement.clientWidth > 959) this.transformElement()
        if (this.transform === 'bypath') this.initByPath()
        this.$root.$on('transformElement', this.transformElement)
    }
}
</script>


<style scoped lang="stylus">
    .block-parallax {
        & > * {
           +layout-sm-and-up() {
               width 100%
               max-width 100%
           }

        }
        img {
            max-width 100%
        }
    }
</style>
